import { ITDSIconGroup } from '../enums/itds-icons.enum';
import { ITDSIconGroups } from '../interfaces/itds-icons.interface';
// COMMERCE
import { Assign } from '../svg/commerce/assign';
import { Barcode } from '../svg/commerce/barcode';
import { Bill } from '../svg/commerce/bill';
import { Bill2 } from '../svg/commerce/bill-2';
import { BillOff } from '../svg/commerce/bill-off';
import { Card } from '../svg/commerce/card';
import { Cart as CommerceCart } from '../svg/commerce/cart';
import { Coins } from '../svg/commerce/coins';
import { CoinsAlt } from '../svg/commerce/coins-alt';
import { Company } from '../svg/commerce/company';
import { CouponAlt } from '../svg/commerce/coupon-alt';
import { CreditCard } from '../svg/commerce/credit-card';
import { DiscountCard } from '../svg/commerce/discount-card';
import { DocumentTAX } from '../svg/commerce/document-tax';
import { DollarSign } from '../svg/commerce/dollar-sign';
import { Gift } from '../svg/commerce/gift';
import { GiftCard } from '../svg/commerce/gift-card';
import { Money } from '../svg/commerce/money';
import { MoneyPlusMinus } from '../svg/commerce/money-plus-minus';
import { Payment } from '../svg/commerce/payment';
import { PriceOverride } from '../svg/commerce/price-override';
import { ShoppingBag } from '../svg/commerce/shopping-bag';
import { ShoppingBagAlt } from '../svg/commerce/shopping-bag-alt';
import { Tag } from '../svg/commerce/tag';
import { TagDiscount } from '../svg/commerce/tag-discount';
import { Transaction } from '../svg/commerce/transaction';
import { Wallet } from '../svg/commerce/wallet';
import { WalletCards } from '../svg/commerce/wallet-cards';
// CONTROLS
import { ChevronsLeft } from '../svg/controls/chevrons-left';
import { Custom } from '../svg/controls/custom';
import { Forward5 } from '../svg/controls/forward-5';
import { History } from '../svg/controls/history';
import { Organizer as ControlsOrganizer } from '../svg/controls/organizer';
import { OrganizerCopy } from '../svg/controls/organizer-copy';
import { PauseOutline } from '../svg/controls/pause-outline';
import { PlayOutline } from '../svg/controls/play-outline';
import { Repeat } from '../svg/controls/repeat';
import { RepeatOne } from '../svg/controls/repeat-one';
import { Rotate } from '../svg/controls/rotate';
import { RotateAlt } from '../svg/controls/rotate-alt';
import { Settings } from '../svg/controls/settings';
import { StopOutline } from '../svg/controls/stop-outline';
// DATA
import { BarChart } from '../svg/data/bar-chart';
import { BarChartAlt } from '../svg/data/bar-chart-alt';
import { Box } from '../svg/data/box';
import { Boxes } from '../svg/data/boxes';
import { Calculate } from '../svg/data/calculate';
import { Circle1Custom } from '../svg/data/circle-1-custom';
import { Dashboard } from '../svg/data/dashboard';
import { DataPump } from '../svg/data/data-pump';
import { Database } from '../svg/data/database';
import { Hash } from '../svg/data/hash';
import { HTMLBuilder } from '../svg/data/html-builder';
import { Layout } from '../svg/data/layout';
import { Line } from '../svg/data/line';
import { Map } from '../svg/data/map';
import { Percent } from '../svg/data/percent';
import { Regions } from '../svg/data/regions';
import { SalesChannels } from '../svg/data/sales-channels';
import { Services } from '../svg/data/services';
import { Sub } from '../svg/data/sub';
import { Table } from '../svg/data/table';
import { Template } from '../svg/data/template';
import { Tools as DataTools } from '../svg/data/tools';
// EVENT TYPE
import { LiveStream } from '../svg/event-type/live-stream';
import { OnSite } from '../svg/event-type/on-site';
import { VideoStream } from '../svg/event-type/video-stream';
// FILES
import { Api } from '../svg/files/api';
import { Camera as FilesCamera } from '../svg/files/camera';
import { Copy } from '../svg/files/copy';
import { CopyNo } from '../svg/files/copy-no';
import { DocumentMultiple02 } from '../svg/files/document-multiple-02';
import { DocumentText } from '../svg/files/document-text';
import { Download } from '../svg/files/download';
import { DownloadCloud } from '../svg/files/download-cloud';
import { Features } from '../svg/files/features';
import { File } from '../svg/files/file';
import { Film } from '../svg/files/film';
import { Loader } from '../svg/files/loader';
import { Music } from '../svg/files/music';
import { Organizer as FilesOrganizer } from '../svg/files/organizer';
import { RegionPageSetttings } from '../svg/files/region-page-setttings';
import { ReportData } from '../svg/files/report-data';
import { Save } from '../svg/files/save';
import { SurveyEdit } from '../svg/files/survey-edit';
import { SurveyList } from '../svg/files/survey-list';
import { Upload } from '../svg/files/upload';
import { Video } from '../svg/files/video';
// FORMATTING
import { AlignLeft } from '../svg/formatting/align-left';
import { Brush } from '../svg/formatting/brush';
import { Crop } from '../svg/formatting/crop';
import { EditBase } from '../svg/formatting/edit-base';
import { EditUnderline } from '../svg/formatting/edit-underline';
import { Enter } from '../svg/formatting/enter';
import { EraseClear } from '../svg/formatting/erase-clear';
import { FormatListBulleted } from '../svg/formatting/format-list-bulleted';
import { FormatListNumbered } from '../svg/formatting/format-list-numbered';
import { Gallery } from '../svg/formatting/gallery';
import { Globe } from '../svg/formatting/globe';
import { Image } from '../svg/formatting/image';
import { Language as FormattingLanguage } from '../svg/formatting/language';
import { LongDescription } from '../svg/formatting/long-description';
import { Quote } from '../svg/formatting/quote';
import { Segment } from '../svg/formatting/segment';
import { ShortDescription } from '../svg/formatting/short-description';
import { Translate } from '../svg/formatting/translate';
import { TrashCan } from '../svg/formatting/trash-can';
import { Type } from '../svg/formatting/type';
import { Type1 } from '../svg/formatting/type-1';
// NAVIGATION
import { Add } from '../svg/navigation/add';
import { AddCircle } from '../svg/navigation/add-circle';
import { AddSquare } from '../svg/navigation/add-square';
import { ArrowDown } from '../svg/navigation/arrow-down';
import { ArrowDownLeft } from '../svg/navigation/arrow-down-left';
import { ArrowDownRight } from '../svg/navigation/arrow-down-right';
import { ArrowLeft } from '../svg/navigation/arrow-left';
import { ArrowRight } from '../svg/navigation/arrow-right';
import { ArrowUp } from '../svg/navigation/arrow-up';
import { ArrowUpLeft } from '../svg/navigation/arrow-up-left';
import { ArrowUpRight } from '../svg/navigation/arrow-up-right';
import { Caret } from '../svg/navigation/caret';
import { CaretDown } from '../svg/navigation/caret-down';
import { CaretLeft } from '../svg/navigation/caret-left';
import { CaretRight } from '../svg/navigation/caret-right';
import { CaretUp } from '../svg/navigation/caret-up';
import { Chevron } from '../svg/navigation/chevron';
import { ChevronDown } from '../svg/navigation/chevron-down';
import { ChevronDownOutline } from '../svg/navigation/chevron-down-outline';
import { ChevronLeft } from '../svg/navigation/chevron-left';
import { ChevronLeftOutline } from '../svg/navigation/chevron-left-outline';
import { ChevronRight } from '../svg/navigation/chevron-right';
import { ChevronRightOutline } from '../svg/navigation/chevron-right-outline';
import { ChevronUp } from '../svg/navigation/chevron-up';
import { ChevronUpOutline } from '../svg/navigation/chevron-up-outline';
import { Close } from '../svg/navigation/close';
import { CloseCircle } from '../svg/navigation/close-circle';
import { CloseSquare } from '../svg/navigation/close-square';
import { DownToBottom } from '../svg/navigation/down-to-bottom';
import { Draggable } from '../svg/navigation/draggable';
import { Home } from '../svg/navigation/home';
import { Logout as NavigationLogout } from '../svg/navigation/logout';
import { MapPin } from '../svg/navigation/map-pin';
import { Menu } from '../svg/navigation/menu';
import { MoreHorizontal } from '../svg/navigation/more-horizontal';
import { MoreHorizontal1 } from '../svg/navigation/more-horizontal-1';
import { PageFirst } from '../svg/navigation/page-first';
import { PageLast } from '../svg/navigation/page-last';
import { Route } from '../svg/navigation/route';
import { Subtract } from '../svg/navigation/subtract';
import { SubtractAlt } from '../svg/navigation/subtract-alt';
import { SubtractLarge } from '../svg/navigation/subtract-large';
import { UpToTop } from '../svg/navigation/up-to-top';
import { ZoomIn } from '../svg/navigation/zoom-in';
import { ZoomInArea } from '../svg/navigation/zoom-in-area';
import { ZoomOut } from '../svg/navigation/zoom-out';
import { ZoomOutArea } from '../svg/navigation/zoom-out-area';
// OPERATION
import { CaretSort } from '../svg/operation/caret-sort';
import { CaretSortDown } from '../svg/operation/caret-sort-down';
import { CaretSortUp } from '../svg/operation/caret-sort-up';
import { ChatBubble } from '../svg/operation/chat-bubble';
import { ChevronSort } from '../svg/operation/chevron-sort';
import { ChevronSortDown } from '../svg/operation/chevron-sort-down';
import { ChevronSortUp } from '../svg/operation/chevron-sort-up';
import { CircleArrowIn } from '../svg/operation/circle-arrow-in';
import { CircleArrowOut } from '../svg/operation/circle-arrow-out';
import { ExternalLink } from '../svg/operation/external-link';
import { Filter } from '../svg/operation/filter';
import { Flag } from '../svg/operation/flag';
import { Language as OperationLanguage } from '../svg/operation/language';
import { Layer } from '../svg/operation/layer';
import { Layers } from '../svg/operation/layers';
import { Login } from '../svg/operation/login';
import { Logout as OperationLogout } from '../svg/operation/logout';
import { Maximize } from '../svg/operation/maximize';
import { MessageCircle } from '../svg/operation/message-circle';
import { MessageSquare } from '../svg/operation/message-square';
import { Minimize } from '../svg/operation/minimize';
import { OneItem } from '../svg/operation/one-item';
import { Scan } from '../svg/operation/scan';
import { Search } from '../svg/operation/search';
import { Send } from '../svg/operation/send';
import { Shuffle } from '../svg/operation/shuffle';
import { SlidersCircleHorizontal } from '../svg/operation/sliders-circle-horizontal';
import { SlidersHorizontal } from '../svg/operation/sliders-horizontal';
import { SquareAdd } from '../svg/operation/square-add';
// OTHER
import { Bolt } from '../svg/other/bolt';
import { Circle } from '../svg/other/circle';
import { Rombus } from '../svg/other/rombus';
import { ShapesCategory } from '../svg/other/shapes-category';
// SMART CITY
import { Accessibility } from '../svg/smart-city/accessibility';
import { AccessibilityAlt } from '../svg/smart-city/accessibility-alt';
import { Badge } from '../svg/smart-city/badge';
import { Bar } from '../svg/smart-city/bar';
import { Bicycle } from '../svg/smart-city/bicycle';
import { Bus } from '../svg/smart-city/bus';
import { Car } from '../svg/smart-city/car';
import { ChargingStation } from '../svg/smart-city/charging-station';
import { Chat } from '../svg/smart-city/chat';
import { ChristmasTree } from '../svg/smart-city/christmas-tree';
import { Clean } from '../svg/smart-city/clean';
import { Construction } from '../svg/smart-city/construction';
import { Crossroads } from '../svg/smart-city/crossroads';
import { Cyclist } from '../svg/smart-city/cyclist';
import { Family } from '../svg/smart-city/family';
import { FamilyAlt } from '../svg/smart-city/family-alt';
import { FillPaint } from '../svg/smart-city/fill-paint';
import { Football } from '../svg/smart-city/football';
import { FootballAlt } from '../svg/smart-city/football-alt';
import { GasStation } from '../svg/smart-city/gas-station';
import { Greenhouse } from '../svg/smart-city/greenhouse';
import { HelpDesk } from '../svg/smart-city/help-desk';
import { Idea } from '../svg/smart-city/idea';
import { InfinitySymbol } from '../svg/smart-city/infinity-symbol';
import { Museum } from '../svg/smart-city/museum';
import { News } from '../svg/smart-city/news';
import { Parking } from '../svg/smart-city/parking';
import { Pin } from '../svg/smart-city/pin';
import { Puzzle } from '../svg/smart-city/puzzle';
import { Questionnaire } from '../svg/smart-city/questionnaire';
import { Road } from '../svg/smart-city/road';
import { Running } from '../svg/smart-city/running';
import { ShoePrint } from '../svg/smart-city/shoe-print';
import { Shower } from '../svg/smart-city/shower';
import { Spray } from '../svg/smart-city/spray';
import { Sprout } from '../svg/smart-city/sprout';
import { Sustainability } from '../svg/smart-city/sustainability';
import { Theater } from '../svg/smart-city/theater';
import { ToolBox } from '../svg/smart-city/tool-box';
import { ToolKit } from '../svg/smart-city/tool-kit';
import { Tools as SmartCityTools } from '../svg/smart-city/tools';
import { TouchInteraction } from '../svg/smart-city/touch-interaction';
import { TrafficCone } from '../svg/smart-city/traffic-cone';
import { TrafficEvent } from '../svg/smart-city/traffic-event';
import { TrafficIncident } from '../svg/smart-city/traffic-incident';
import { TrafficLight } from '../svg/smart-city/traffic-light';
import { TrainProfile } from '../svg/smart-city/train-profile';
import { UsersGroup } from '../svg/smart-city/users-group';
import { Van } from '../svg/smart-city/van';
import { WalkerPedestrian } from '../svg/smart-city/walker-pedestrian';
import { WeedMaintenance } from '../svg/smart-city/weed-maintenance';
// SOCIAL MEDIA
import { LogoFacebook } from '../svg/social-media/logo-facebook';
import { LogoInstagram } from '../svg/social-media/logo-instagram';
import { LogoLinkedin } from '../svg/social-media/logo-linkedin';
import { LogoPinterest } from '../svg/social-media/logo-pinterest';
import { LogoX } from '../svg/social-media/logo-x';
import { LogoYoutube } from '../svg/social-media/logo-youtube';
// STATUS
import { CheckSquare } from '../svg/status/check-square';
import { Checkmark } from '../svg/status/checkmark';
import { CheckmarkCircleOut } from '../svg/status/checkmark-circle-out';
import { CheckmarkFilled } from '../svg/status/checkmark-filled';
import { CheckmarkOutline } from '../svg/status/checkmark-outline';
import { Error } from '../svg/status/error';
import { ErrorFilled } from '../svg/status/error-filled';
import { ErrorOutline } from '../svg/status/error-outline';
import { Help } from '../svg/status/help';
import { HelpFilled } from '../svg/status/help-filled';
import { Information } from '../svg/status/info';
import { InformationFilled } from '../svg/status/information-filled';
import { Warning } from '../svg/status/warning';
import { WarningAlt } from '../svg/status/warning-alt';
import { WarningAltFilled } from '../svg/status/warning-alt-filled';
import { WarningFilled } from '../svg/status/warning-filled';
// TECHNOLOGY
import { Blockchain } from '../svg/technology/blockchain';
import { Camera as TechnologyCamera } from '../svg/technology/camera';
import { Code } from '../svg/technology/code';
import { Email } from '../svg/technology/email';
import { EmailNew } from '../svg/technology/email-new';
import { Laptop } from '../svg/technology/laptop';
import { Locked } from '../svg/technology/locked';
import { Mobile } from '../svg/technology/mobile';
import { Monitor } from '../svg/technology/monitor';
import { NFT } from '../svg/technology/nft';
import { PasswordKey } from '../svg/technology/password-key';
import { Phone } from '../svg/technology/phone';
import { Printer } from '../svg/technology/printer';
import { PublicSite } from '../svg/technology/public-site';
import { QrCode } from '../svg/technology/qr-code';
import { Rocket } from '../svg/technology/rocket';
import { Share } from '../svg/technology/share';
import { SwitchDevice } from '../svg/technology/switch-device';
import { Unlocked } from '../svg/technology/unlocked';
// TICKETING
import { Auditorium } from '../svg/ticketing/auditorium';
import { NoTicket } from '../svg/ticketing/no-ticket';
import { SalesChannelsBoxOffice } from '../svg/ticketing/sales-channels-box-office';
import { SalesChannelsMobile } from '../svg/ticketing/sales-channels-mobile';
import { SalesChannelsWeb } from '../svg/ticketing/sales-channels-web';
import { SeasonTicket } from '../svg/ticketing/season-ticket';
import { SeatedPlace } from '../svg/ticketing/seated-place';
import { Sectors } from '../svg/ticketing/sectors';
import { Sofa } from '../svg/ticketing/sofa';
import { Stairs } from '../svg/ticketing/stairs';
import { StandingPlaceDynamic } from '../svg/ticketing/standing-place-dynamic';
import { Ticket } from '../svg/ticketing/ticket';
import { TicketDone } from '../svg/ticketing/ticket-done';
import { TicketGroup } from '../svg/ticketing/ticket-group';
import { TicketHorizontal } from '../svg/ticketing/ticket-horizontal';
import { TicketSell } from '../svg/ticketing/ticket-sell';
import { TicketSold } from '../svg/ticketing/ticket-sold';
import { ViewRestrictions } from '../svg/ticketing/view-restrictions';
// TIME ICONS
import { Calendar } from '../svg/time-icons/calendar';
import { Calendar1 } from '../svg/time-icons/calendar-1';
import { CalendarAdd } from '../svg/time-icons/calendar-add';
import { CalendarCheck } from '../svg/time-icons/calendar-check';
import { CalendarDateRange } from '../svg/time-icons/calendar-date-range';
import { CalendarDays } from '../svg/time-icons/calendar-days';
import { CalendarTime } from '../svg/time-icons/calendar-time';
import { CalendarWithNumber } from '../svg/time-icons/calendar-with-number';
import { Event } from '../svg/time-icons/event';
import { Expired } from '../svg/time-icons/expired';
import { Hourglass } from '../svg/time-icons/hourglass';
import { NewEvent } from '../svg/time-icons/new-event';
import { Program } from '../svg/time-icons/program';
import { Time } from '../svg/time-icons/time';
// TOGGLE ICONS
import { Cart } from '../svg/toggle-icons/cart';
import { CartOff } from '../svg/toggle-icons/cart-off';
import { Column } from '../svg/toggle-icons/column';
import { Favorite } from '../svg/toggle-icons/favorite';
import { FavoriteFilled } from '../svg/toggle-icons/favorite-filled';
import { Grid } from '../svg/toggle-icons/grid';
import { Light } from '../svg/toggle-icons/light';
import { LightFilled } from '../svg/toggle-icons/light-filled';
import { LinesSquare } from '../svg/toggle-icons/lines-square';
import { Link } from '../svg/toggle-icons/link';
import { LinkAlt } from '../svg/toggle-icons/link-alt';
import { List } from '../svg/toggle-icons/list';
import { NightMoon } from '../svg/toggle-icons/night-moon';
import { NightMoonFilled } from '../svg/toggle-icons/night-moon-filled';
import { Notification } from '../svg/toggle-icons/notification';
import { NotificationFilled } from '../svg/toggle-icons/notification-filled';
import { Row } from '../svg/toggle-icons/row';
import { Sparkles } from '../svg/toggle-icons/sparkles';
import { Star } from '../svg/toggle-icons/star';
import { StarFilled } from '../svg/toggle-icons/star-filled';
import { StarFilledLittle } from '../svg/toggle-icons/star-filled-little';
import { StarHalf } from '../svg/toggle-icons/star-half';
import { StarLittle } from '../svg/toggle-icons/star-little';
import { Unlink } from '../svg/toggle-icons/unlink';
import { View } from '../svg/toggle-icons/view';
import { ViewOff } from '../svg/toggle-icons/view-off';
// USER
import { Account } from '../svg/user/account';
import { Administration } from '../svg/user/administration';
import { Contact } from '../svg/user/contact';
import { Crown } from '../svg/user/crown';
import { CustomerBuyer } from '../svg/user/customer-buyer';
import { CustomerSupport } from '../svg/user/customer-support';
import { Entry } from '../svg/user/entry';
import { Identification } from '../svg/user/identification';
import { IdentificationSettings } from '../svg/user/identification-settings';
import { NoEntry } from '../svg/user/no-entry';
import { PartnerPageSetttings } from '../svg/user/partner-page-setttings';
import { PartnerSetttings } from '../svg/user/partner-setttings';
import { PedestrianWalking } from '../svg/user/pedestrian-walking';
import { Rated } from '../svg/user/rated';
import { Rater } from '../svg/user/rater';
import { StopHand } from '../svg/user/stop-hand';
import { User } from '../svg/user/user';
import { UserCheck } from '../svg/user/user-check';
import { UserEdit } from '../svg/user/user-edit';
import { UserManagement } from '../svg/user/user-management';
import { UserMultiple } from '../svg/user/user-multiple';
import { UserPlus } from '../svg/user/user-plus';
import { UserSettings } from '../svg/user/user-settings';
import { UserSuperAdminCrown } from '../svg/user/user-super-admin-crown';
import { UsersRoles } from '../svg/user/users-roles';
// WEATHER
import { Rain } from '../svg/weather/rain';
import { RainDrop } from '../svg/weather/rain-drop';
import { Snowflake } from '../svg/weather/snowflake';
import { Sunrise } from '../svg/weather/sunrise';
import { Sunset } from '../svg/weather/sunset';
import { WindGusts } from '../svg/weather/wind-gusts';
import { WindStream } from '../svg/weather/wind-stream';

/**
 * ITDS Icon set in groups
 * Figma: https://www.figma.com/design/WOSWwiLtSxupJFmOHbwAHw/%E2%AD%90-Icons---Interticket-Design-Language?node-id=1-5200&m=dev
 * Exports: https://drive.google.com/drive/folders/1VR0SXqRjLFUkrgri04J6Bgv_E4t-p0Ri
 */
export const ITDSIconPack: ITDSIconGroups = {

  // COMMERCE (26)
  [ITDSIconGroup.COMMERCE]: {
    Assign,
    Barcode,
    Bill,
    Bill2,
    BillOff,
    Card,
    CommerceCart,
    Coins,
    CoinsAlt,
    Company,
    CouponAlt,
    CreditCard,
    DiscountCard,
    DocumentTAX,
    DollarSign,
    Gift,
    GiftCard,
    Money,
    MoneyPlusMinus,
    Payment,
    PriceOverride,
    ShoppingBag,
    ShoppingBagAlt,
    Tag,
    TagDiscount,
    Transaction,
    Wallet,
    WalletCards,
  },

  // CONTROLS (14)
  [ITDSIconGroup.CONTROLS]: {
    ChevronsLeft,
    Custom,
    Forward5,
    History,
    ControlsOrganizer,
    OrganizerCopy,
    PauseOutline,
    PlayOutline,
    Repeat,
    RepeatOne,
    Rotate,
    RotateAlt,
    Settings,
    StopOutline,
  },

  // DATA (22)
  [ITDSIconGroup.DATA]: {
    BarChart,
    BarChartAlt,
    Box,
    Boxes,
    Calculate,
    Circle1Custom,
    Dashboard,
    DataPump,
    Database,
    Hash,
    HTMLBuilder,
    Layout,
    Line,
    Map,
    Percent,
    Regions,
    SalesChannels,
    Services,
    Sub,
    Table,
    Template,
    DataTools,
  },

  // EVENT TYPE (3)
  [ITDSIconGroup.EVENT_TYPE]: {
    LiveStream,
    OnSite,
    VideoStream,
  },

  // FILES (21)
  [ITDSIconGroup.FILES]: {
    Api,
    FilesCamera,
    Copy,
    CopyNo,
    DocumentMultiple02,
    DocumentText,
    Download,
    DownloadCloud,
    Features,
    File,
    Film,
    Loader,
    Music,
    FilesOrganizer,
    RegionPageSetttings,
    ReportData,
    Save,
    SurveyEdit,
    SurveyList,
    Upload,
    Video,
  },

  // FORMATTING (21)
  [ITDSIconGroup.FORMATTING]: {
    AlignLeft,
    Brush,
    Crop,
    EditBase,
    EditUnderline,
    Enter,
    EraseClear,
    FormatListBulleted,
    FormatListNumbered,
    Gallery,
    Globe,
    Image,
    FormattingLanguage,
    LongDescription,
    Quote,
    Segment,
    ShortDescription,
    Translate,
    TrashCan,
    Type,
    Type1,
  },

  // NAVIGATION (42)
  [ITDSIconGroup.NAVIGATION]: {
    Add,
    AddCircle,
    AddSquare,
    ArrowDown,
    ArrowDownLeft,
    ArrowDownRight,
    ArrowLeft,
    ArrowRight,
    ArrowUp,
    ArrowUpLeft,
    ArrowUpRight,
    Caret,
    CaretDown,
    CaretLeft,
    CaretRight,
    CaretUp,
    Chevron,
    ChevronDown,
    ChevronDownOutline,
    ChevronLeft,
    ChevronLeftOutline,
    ChevronRight,
    ChevronRightOutline,
    ChevronUp,
    ChevronUpOutline,
    Close,
    CloseCircle,
    CloseSquare,
    DownToBottom,
    Draggable,
    Home,
    NavigationLogout,
    MapPin,
    Menu,
    MoreHorizontal,
    MoreHorizontal1,
    PageFirst,
    PageLast,
    Route,
    Subtract,
    SubtractAlt,
    SubtractLarge,
    UpToTop,
    ZoomIn,
    ZoomInArea,
    ZoomOut,
    ZoomOutArea,
  },

  // OPERATION (29)
  [ITDSIconGroup.OPERATION]: {
    CaretSort,
    CaretSortDown,
    CaretSortUp,
    ChatBubble,
    ChevronSort,
    ChevronSortDown,
    ChevronSortUp,
    CircleArrowIn,
    CircleArrowOut,
    ExternalLink,
    Filter,
    Flag,
    OperationLanguage,
    Layer,
    Layers,
    Login,
    OperationLogout,
    Maximize,
    MessageCircle,
    MessageSquare,
    Minimize,
    OneItem,
    Scan,
    Search,
    Send,
    Shuffle,
    SlidersCircleHorizontal,
    SlidersHorizontal,
    SquareAdd,
  },

  // OTHER (4)
  [ITDSIconGroup.OTHER]: {
    Bolt,
    Circle,
    Rombus,
    ShapesCategory,
  },

  // SMART CITY (51)
  [ITDSIconGroup.SMART_CITY]: {
    Accessibility,
    AccessibilityAlt,
    Badge,
    Bar,
    Bicycle,
    Bus,
    Car,
    ChargingStation,
    Chat,
    ChristmasTree,
    Clean,
    Construction,
    Crossroads,
    Cyclist,
    Family,
    FamilyAlt,
    FillPaint,
    Football,
    FootballAlt,
    GasStation,
    Greenhouse,
    HelpDesk,
    Idea,
    InfinitySymbol,
    Museum,
    News,
    Parking,
    Pin,
    Puzzle,
    Questionnaire,
    Road,
    Running,
    ShoePrint,
    Shower,
    Spray,
    Sprout,
    Sustainability,
    Theater,
    ToolBox,
    ToolKit,
    SmartCityTools,
    TouchInteraction,
    TrafficCone,
    TrafficEvent,
    TrafficIncident,
    TrafficLight,
    TrainProfile,
    UsersGroup,
    Van,
    WalkerPedestrian,
    WeedMaintenance,
  },

  // SOCIAL MEDIA (6)
  [ITDSIconGroup.SOCIAL_MEDIA]: {
    LogoFacebook,
    LogoInstagram,
    LogoLinkedin,
    LogoPinterest,
    LogoX,
    LogoYoutube,
  },

  // STATUS (16)
  [ITDSIconGroup.STATUS]: {
    CheckSquare,
    Checkmark,
    CheckmarkCircleOut,
    CheckmarkFilled,
    CheckmarkOutline,
    Error,
    ErrorFilled,
    ErrorOutline,
    Help,
    HelpFilled,
    Information,
    InformationFilled,
    Warning,
    WarningAlt,
    WarningAltFilled,
    WarningFilled,
  },

  // TECHNOLOGY (19)
  [ITDSIconGroup.TECHNOLOGY]: {
    Blockchain,
    TechnologyCamera,
    Code,
    Email,
    EmailNew,
    Laptop,
    Locked,
    Mobile,
    Monitor,
    NFT,
    PasswordKey,
    Phone,
    Printer,
    PublicSite,
    QrCode,
    Rocket,
    Share,
    SwitchDevice,
    Unlocked,
  },

  // TICKETING (18)
  [ITDSIconGroup.TICKETING]: {
    Auditorium,
    NoTicket,
    SalesChannelsBoxOffice,
    SalesChannelsMobile,
    SalesChannelsWeb,
    SeasonTicket,
    SeatedPlace,
    Sectors,
    Sofa,
    Stairs,
    StandingPlaceDynamic,
    Ticket,
    TicketDone,
    TicketGroup,
    TicketHorizontal,
    TicketSell,
    TicketSold,
    ViewRestrictions,
  },

  // TIME ICONS (14)
  [ITDSIconGroup.TIME_ICONS]: {
    Calendar,
    Calendar1,
    CalendarAdd,
    CalendarCheck,
    CalendarDateRange,
    CalendarDays,
    CalendarTime,
    CalendarWithNumber,
    Event,
    Expired,
    Hourglass,
    NewEvent,
    Program,
    Time,
  },

  // TOGGLE ICONS (26)
  [ITDSIconGroup.TOGGLE_ICONS]: {
    Cart,
    CartOff,
    Column,
    Favorite,
    FavoriteFilled,
    Grid,
    Light,
    LightFilled,
    LinesSquare,
    Link,
    LinkAlt,
    List,
    NightMoon,
    NightMoonFilled,
    Notification,
    NotificationFilled,
    Row,
    Sparkles,
    Star,
    StarFilled,
    StarFilledLittle,
    StarHalf,
    StarLittle,
    Unlink,
    View,
    ViewOff,
  },

  // USER (25)
  [ITDSIconGroup.USER]: {
    Account,
    Administration,
    Contact,
    Crown,
    CustomerBuyer,
    CustomerSupport,
    Entry,
    Identification,
    IdentificationSettings,
    NoEntry,
    PartnerPageSetttings,
    PartnerSetttings,
    PedestrianWalking,
    Rated,
    Rater,
    StopHand,
    User,
    UserCheck,
    UserEdit,
    UserManagement,
    UserMultiple,
    UserPlus,
    UserSettings,
    UserSuperAdminCrown,
    UsersRoles,
  },

  // WEATHER (7)
  [ITDSIconGroup.WEATHER]: {
    Rain,
    RainDrop,
    Snowflake,
    Sunrise,
    Sunset,
    WindGusts,
    WindStream,
  },

};
